<template>
  <tr v-if="item.type === 0">
    <td class="group_res">
      {{ name }}({{ item.online }} / {{ item.count }})
    </td>
  </tr>
  <tr v-else-if="item.type === -1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()">
    <tr class="link">
      <td v-if="checkbox" class="checkbox_table" :data-label="translate('check_it')">
        <input v-model="item.checked" :checked="checked" type="checkbox" @click.stop="check">
      </td>
      <td :data-label="translate('status')" class="status w50">
        <sis-icon-status :status="+item.active" />
      </td>
      <td :data-label="translate('simcard_devices.tariff_status')" class="w100">
        <span v-if="item.device_tariffication_status" class="mdi mdi-currency-rub tariffication"/>
      </td>
      <td :data-label="translate('simcard_devices.device_status')" class="w100">
        <span v-if="item.device_status" class="mdi mdi-access-point online" />
        <span v-else class="mdi mdi-access-point-off offline" />
      </td>
      <td :data-label="translate('simcard_devices.fid')">
        <router-link :to="{path: '/device/' + item.device_fid}">
          {{ item.device_fid }}
        </router-link>
        <p>{{item.device_name}}</p>
      </td>
      <td :data-label="translate('simcard_devices.client')">
        <router-link v-if="item.device_owner_client_info !== null" :to="{path: '/client/' + item.device_owner_client_info.client_id}">
          {{ item.device_owner_client_info.client_name }}
        </router-link>
      </td>
      <td :data-label="translate('simcard_devices.group')">
        <router-link :to="{path: '/simcard_devices_list?&group=' + item.group_id}">
          {{ simcard_devices_group }}
        </router-link>
      </td>
      <td :data-label="translate('simcard_devices.ts_sync')">
        {{ get_date(item.ts_sync) }}
      </td>
      <td :data-label="translate('simcard_devices.mno')">
        {{ item.mno }}
      </td>
      <td :data-label="translate('simcard_devices.apn')">
        {{ item.apn }}
      </td>
      <td :data-label="translate('simcard_devices.number')">
        {{ item.number }}
      </td>
      <td :data-label="translate('simcard_devices.imsi')">
        {{ item.imsi }}
      </td>
      <td :data-label="translate('simcard_devices.iccid')">
        {{ item.iccid }}
      </td>
    </tr>
  </router-link>

</template>
<script>
import SisIconStatus from 'components/UIComponents/Icon/SisIconStatus.vue'

export default {
  name: 'SimCardDevicesListItem',
  components: {
    SisIconStatus
  },
  props: {
    item: Object,
    index: [Number, String],
    checked: [Number, String, Boolean],
    checkbox: {
      type: Boolean,
      default: true
    },
    groups: Array
  },
  data() {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    name() {
      if (this.item.type === 0) {
        return this.$store.getters.getSimcardDevicesGroupById(this.item.id).name
      }
      else {
        let name = this.item.name2
        if (this.$store.getters.getPermissions.permissionGod) {
          name += ' / '
          name += this.item.name
        }
        return name
      }
    },
    simcard_devices_group(){
      return this.$store.getters.getSimcardDevicesGroupById(this.item.group_id).name
    }
  },
  activated() {
    this.$emit('mount', this.index)
  },
  mounted() {
    this.$emit('mount', this.index)
  },
  methods: {
    check() {
      this.$emit('check', !this.item.checked, this.item.device_id)
    },
    go_to() {
      return { path: '/simcard_devices/' + this.item.imsi }
    },
    ready() {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>

.response_table .checkbox_table {
  width: 30px;
}

.link {
  margin-top: -1px;
  vertical-align: middle;
  font-size: 12px;
  &:hover{
    background-color: #f1f1f1;
    color: black;
  }
  a, p{
    margin: 0;
    font-size: 12px;
  }
  span.mdi{
    font-size: 18px;
    &.online{
      color: #15ab00;
    }
    &.tariffication{
      color: #3f93d3;
    }
  }
}

.group_res {
  cursor: auto;
}
</style>
